<template>
     <ion-card :style="{ '--i': i }" v-if="item.idBlockType === 6" class="induction-card">
        <ion-card-header>
          <div class="lock-status">
            <ion-icon :icon="lockClosed"></ion-icon>
          </div>

          <ion-card-content class="ion-no-padding">
            <PrenotaAppuntamento
              v-if="whappyClientConfig.name == 'Automotive SpA'"
              currentMentorAvatar="https://randomuser.me/api/portraits/men/3.jpg"
              :mentor="{
                name: 'Jon Doe',
                role: 'Admin',
                img: 'https://randomuser.me/api/portraits/men/3.jpg',
              }"
              currentDate="2022-12-31:17:00:00"
              title="Ora che sei pronto proponi il giorno e ora l'affiancamento con il tuo collega, riceverai il feedback in breve tempo"
              :immediateScroll="false"
            />
          </ion-card-content>
        </ion-card-header>
      </ion-card>
</template>
<script>
import { defineComponent } from "vue";
import { lockClosed } from "ionicons/icons";
import PrenotaAppuntamento from "../../views/pk_views/components/PrenotaAppuntamento.vue";

export default defineComponent({
  components: {
    PrenotaAppuntamento,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    whappyClientConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lockClosed,
    };
  },
});
</script>
<style scoped>
.induction-card {
  //background: var(--folder-bg-color) !important;
  background: black !important;
}
.lock-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.lock-status.locked ion-icon {
  color: #FF4757;
}
.lock-status.unlocked ion-icon {
  color: #2ECC71;
}


</style>

